import React, { createContext, useContext, useState } from "react";

const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [signedInCheckoutOpen, setSignedInCheckoutOpen] = useState(false);
  return (
    <ModalContext.Provider
      value={{
        isCheckoutOpen,
        setIsCheckoutOpen,
        signedInCheckoutOpen,
        setSignedInCheckoutOpen,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
